import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import axios from "axios";

const DoctorSelectDropdown = ({ selectedDoctor, setSelectedDoctor }) => {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_KAIZEN_API}/api/dev2/doctors`)
      .then((res) => setDoctors(res.data));
  }, []);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 250, // controls height of dropdown list
        overflowY: "auto",
      },
    },
  };

  return (
    <FormControl fullWidth>
      <InputLabel>Select Doctor</InputLabel>
      <Select
        value={selectedDoctor?.id || ""}
        label="Select Doctor"
        onChange={(e) =>
          setSelectedDoctor(doctors.find((d) => d.id === e.target.value))
        }
        MenuProps={MenuProps}
      >
        {doctors.map((doc) => (
          <MenuItem key={doc.id} value={doc.id}>
            {doc.firstname}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DoctorSelectDropdown;
